"use strict";
'use es6';

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _react = _interopRequireWildcard(require("react"));

var _colors = require("HubStyleTokens/colors");

var UINanoProgressBar =
/*#__PURE__*/
function (_Component) {
  (0, _inherits2.default)(UINanoProgressBar, _Component);

  function UINanoProgressBar(props) {
    var _this;

    (0, _classCallCheck2.default)(this, UINanoProgressBar);
    _this = (0, _possibleConstructorReturn2.default)(this, (0, _getPrototypeOf2.default)(UINanoProgressBar).call(this, props));
    var value = props.value; // If 100%, don't even show the progress bar.

    _this.state = {
      value: value === null || value >= 100 ? null : value
    }; // Always keep track of setTimeout id so if the component is unmounted
    // we can cancel any previous timer.

    _this.timerId = null;
    return _this;
  }

  (0, _createClass2.default)(UINanoProgressBar, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.incrementProgress();
    }
  }, {
    key: "componentWillReceiveProps",
    value: function componentWillReceiveProps(nextProps) {
      if (this.props.value !== nextProps.value) {
        if (nextProps.value >= 100) {
          this.completeProgress();
        } else {
          this.incrementProgress(nextProps.value);
        }
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      var value = this.state.value;
      clearTimeout(this.timerId);

      if (value === null || value >= 100) {
        this.setState({
          value: null
        });
      }
    }
  }, {
    key: "incrementProgress",
    value: function incrementProgress(nextValue) {
      var _this2 = this;

      var _this$props = this.props,
          initialValue = _this$props.initialValue,
          optimismFactor = _this$props.optimismFactor,
          optimismIncrement = _this$props.optimismIncrement;
      clearTimeout(this.timerId);
      var currentValue = this.state.value;

      if (nextValue !== null && nextValue >= currentValue) {
        this.setState({
          value: Math.max(nextValue, initialValue)
        });
        this.timerId = setTimeout(function () {
          return _this2.incrementProgress();
        }, optimismIncrement);
      } else if (currentValue) {
        // Increment 25% of the remaining space.
        // The progress bar won't reach 100% until completeProgress is called
        this.setState({
          value: currentValue + (100 - currentValue) * optimismFactor
        });
        this.timerId = setTimeout(function () {
          return _this2.incrementProgress();
        }, optimismIncrement);
      }
    }
  }, {
    key: "completeProgress",
    value: function completeProgress() {
      var _this3 = this;

      var _this$props2 = this.props,
          completionLinger = _this$props2.completionLinger,
          optimismIncrement = _this$props2.optimismIncrement;
      clearTimeout(this.timerId);
      this.timerId = setTimeout(function () {
        _this3.setState({
          value: 100
        }); // Move progress bar to 100%, then give the css some time to transition and let it
        // stick around for a while before firing the done action.


        _this3.timerId = setTimeout(function () {
          return _this3.setState({
            value: null
          });
        }, completionLinger);
      }, optimismIncrement);
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props3 = this.props,
          color = _this$props3.color,
          height = _this$props3.height,
          className = _this$props3.className;
      var value = this.state.value;

      if (!value) {
        return null;
      }

      return _react.default.createElement("div", {
        className: className + " nano-progress-bar"
      }, _react.default.createElement("div", {
        style: {
          width: value + "%",
          background: color,
          boxShadow: "0 0 " + height * 3 + "px " + color,
          height: height + "px",
          transition: 'all 200ms ease'
        }
      }));
    }
  }]);
  return UINanoProgressBar;
}(_react.Component);

UINanoProgressBar.propTypes = {
  // Actual progress
  value: _react.PropTypes.number,
  // Time to allow the progress bar to linger after it's complete
  completionLinger: _react.PropTypes.number,
  // Time to start the progress bar at to be super optimistic
  initialValue: _react.PropTypes.number,
  // Percentage to optimistically creep the bar on each increment
  optimismFactor: _react.PropTypes.number,
  // Time interval to make optimisitc creeps
  optimismIncrement: _react.PropTypes.number,
  className: _react.PropTypes.string,
  color: _react.PropTypes.string,
  height: _react.PropTypes.number
};
UINanoProgressBar.defaultProps = {
  value: null,
  initialValue: 0,
  completionLinger: 500,
  optimismFactor: 0,
  optimismIncrement: 150,
  className: '',
  color: _colors.SORBET,
  height: 2
};
var _default = UINanoProgressBar;
exports.default = _default;
module.exports = exports.default;